export default {
  mixed3a_fur_precursors: [46, 47, 26, 63, 80, 23, 16],

  mixed3a_line_grad: [151, 27, 54, 150, 72, 146, 57, 6],

  mixed3a_eyes: [174, 168, 79, 125, 175],

  mixed3a_highlow: [
    110,
    180,
    153,
    106,
    112,
    186,
    132,
    136,
    117,
    113,
    108,
    70,
    86,
    88,
    160,
  ],

  mixed3a_gradient: [
    206,
    216,
    28,
    127,
    29,
    22,
    182,
    15,
    249,
    25,
    196,
    18,
    59,
    162,
    247,
  ],

  mixed3a_texture_grad: [229, 93, 243, 99, 45, 33, 135, 231, 60, 235],

  mixed3a_bw_color: [222, 197, 223, 201, 204, 214, 208, 210, 220],

  mixed3a_color_contrast: [
    195,
    84,
    85,
    123,
    203,
    217,
    199,
    211,
    205,
    212,
    202,
    200,
    138,
  ],
  mixed3a_center_surround: [
    119,
    34,
    167,
    76,
    19,
    30,
    131,
    251,
    226,
    13,
    7,
    50,
    1,
    4,
    41,
    192,
    36,
    40,
    103,
    213,
    10,
    35,
    221,
    193,
    158,

    73,
    74,
    177,
    97,
    141,
  ],

  mixed3a_lines: [134, 169, 69, 154, 101, 75],

  mixed3a_curve: [104, 92, 95, 145, 147, 137, 81, 71, 189, 163],

  mixed3a_tri_and_angle: [188, 94, 164, 107, 77, 176, 157, 149],

  mixed3a_line_misc: [
    173,
    191,
    133,
    96,
    159,
    121,
    116,
    14,
    82,

    165,
    83,
    187,
    91,
    185,
    64,
    118,
    100,
    152,
    171,
    87,
    90,
    24,
    0,
  ],

  mixed3a_thick_lines: [140, 78, 89],

  mixed3a_pattern: [237, 31, 17, 20, 39, 126, 124, 156, 98, 105, 230],

  mixed3a_edges_pattern: [227, 240, 228, 239, 66, 129, 245, 248],

  mixed3a_pure_texture: [
    246,
    242,
    253,
    232,
    233,
    209,
    139,
    65,
    44,
    51,
    194,
    207,
    218,
    224,
    225,
    215,
    198,
    62,
    21,
    254,
    255,
    61,

    2,
    3,
    8,
    12,
    53,
    56,
    102,
    148,
  ],

  mixed3a_complex_center: [
    178,
    181,
    161,
    166,
    172,
    68,
    130,
    49,
    52,
    114,
    115,
    120,
    144,
    37,
  ],
}
